export let getClient = async (profileId, setClient, setClientAddress, setClientMailingAddress, setClientBillingAddress, API_URL, authTokens, setClientCountry) => {
  if (profileId === 'new') return

  let response = await fetch(`${API_URL}/client/profile/${profileId}/`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + authTokens?.access
    }
  })
  let data = await response.json()

  let businessAddress = data.clientAddress
  let mailingAddress = data.clientMailingAddress
  let billingAddress = data.clientBillingAddress
  let country = businessAddress.map((address) => address.country)

  let responseCountry = await fetch(`${API_URL}/system/referencedata/geographical/country/${country}/`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + authTokens?.access
    }
  })
  let dataCountry = await responseCountry.json()

  setClientCountry(dataCountry)
  setClientAddress(businessAddress)
  setClientMailingAddress(mailingAddress)
  setClientBillingAddress(billingAddress)
  setClient(data)
}